import React from "react";

interface Props {
  style?: React.CSSProperties;
}

const PlayIcon = (props: Props) => {
  const { style } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      // xmlns:xlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 38.868 39.559"
      style={style ? style : undefined}
    >
      <defs>
        {/* <filter
      id="a"
      x="0" y="0"
      width="38.868"
      height="44.559"
      filterUnits="userSpaceOnUse"
    >
      <feOffset dy="3" input="SourceAlpha"/>
      <feGaussianBlur stdDeviation="3" result="b"/>
      <feFlood floodOpacity="0.161"/>
      <feComposite operator="in" in2="b"/>
      <feComposite in="SourceGraphic"/>
    </filter> */}
      </defs>
      <g
        // class="b"
        transform="matrix(1, 0, 0, 1, 0, 0)"
      >
        <path
          // class="a"
          d="M81.9,38.8l20.868,13.28L81.9,65.359Z"
          transform="translate(-72.9 -32.8)"
        />
      </g>
    </svg>
  );
};

export default PlayIcon;
